import { JSX } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";
import { Accordion } from "~/components/webstore_telescope/accordian_faq_section";

export function FootNotesSection(): JSX.Element {
  const { routeData } = useBrandl2WebstoreTelescopeContext();
  const footNotes = routeData().brandExtraMetadata.footNotes;
  return (
    <Accordion
      faqs={footNotes.map((footNote) => ({
        question: footNote.title,
        answer: footNote.description,
      }))}
      title={null}
    />
  );
}
